import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import TreeSection from './TreeSection';
import {useGetFoldersList} from '../../../hooks/corpus/useCorpus';
import {t} from 'i18next';

const Folders = () => {
  const userSecurityGroupId = useSelector(
    (state: RootState) => state.authenticatedUser.user.securityGroupId
  );
  const securityGroupId =
    useSelector(
      (state: RootState) => state.roleImpersonation.prefill.securityGroup?.id
    ) ??
    userSecurityGroupId ??
    0;

  return (
    <TreeSection
      fetchHook={useGetFoldersList}
      securityGroupId={securityGroupId}
      type={t('corpus.sectionType.folders')}
    />
  );
};

export default Folders;
